<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
    <v-alert type="info">
      {{ $t('register.showOtp') }}
    </v-alert>
    <v-text-field
      :label="$t('register.otpCode')"
      outlined
      v-model="form.otpCode"
      data-cy="register-otpCode"
      :prepend-inner-icon="mdiLock"
      :rules="rules.required"
    />
    <v-text-field
      :label="$t('register.email')"
      :hint="$t('register.emailHint')"
      :rules="rules.required"
      type="email"
      v-model="form.email"
      :prepend-icon="mdiMail"
    />
    <PasswordField v-model="form.password"
      :label="$t('register.password')"
      :hint="$t('register.passwordHint')"
      :rules="rules.passwordRules"
      :min="8"
    />
    <v-alert type="error" v-for="error in errors" :key="error">
      {{ error }}
    </v-alert>
    <v-btn
      class="primary mb-2 rounded-0 text-capitalize block"
      style="width: 100%"
      :loading="isLoading"
      type="submit"
      data-cy="register-registerWithOtp"
    >
      {{ $t('register.registerWithOtp') }}
    </v-btn>
  </v-form>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import { mdiLock, mdiMail } from '@mdi/js';
import PasswordField from '@codehq/aurora-app-core/src/components/PasswordField.vue';
import authMixins from './auth-mixins';

export default {
  name: 'FormRegister',
  components: {
    PasswordField,
  },
  mixins: [authMixins, loading],
  props: {
    phoneNumber: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      mdiLock,
      mdiMail,
      valid: true,
      form: {
        email: '',
        phoneNumber: '',
        password: '',
        repeat: '',
        errors: '',
      },
    };
  },
  methods: {
    ...mapActions('auth', ['LOGIN_auth']),
    ...mapMutations('app', ['SET_error', 'SET_token', 'SET_username', 'SET_roles', 'SET_userId', 'SET_refresh_token', 'SET_token_expires_in', 'SET_token_expires']),
    async submit() {
      if (this.$refs.form.validate()) {
        let isRegisterSuccess = false;
        try {
          this.errors = [];
          this.isLoading = true;
          const registerResult = await this.$http.post('/join/register', {
            phoneNumber: this.phoneNumber,
            email: this.form.email,
            code: this.form.otpCode,
            password: this.form.password,
          });
          this.$root.$emit('auth:register', registerResult.data);
          isRegisterSuccess = true;
        } catch (error) {
          const { response } = error;
          const { request, ...errorObject } = response; //
          if (errorObject.status === 400) {
            this.errors = [
              this.$t(errorObject.data?.message ?? 'common.error.basic'),
            ];
            if (errorObject.data?.modelState['']) {
              this.errors.push(errorObject.data?.modelState['']);
            }
          }
        } finally {
          this.isLoading = false;
        }
        // this.state = 'changePassword';
        if (isRegisterSuccess) {
          try {
            this.isLoading = true;
            const { password } = this.form;
            const { phoneNumber } = this;
            this.$log.info(`Logging on ${phoneNumber}`);
            const result = await this.LOGIN_auth({ username: phoneNumber, password });
            this.$root.$emit('auth:login', result.data);
          } catch (error) {
            const { response } = error;
            const { request, ...errorObject } = response; //
            if (errorObject.status === 400) {
              this.errors = [this.$t(errorObject.data?.message ?? 'common.error.basic')];
            }
          } finally {
            this.isLoading = false;
          }
        }
      }
    },
  },
};
</script>
